var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M19 1a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 2H5v18h14zm-3 13a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm0-5a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm0-5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }